import ComingSoon from "../../other/ComingSoon";
import {usePageTitle} from "_hooks";
import {useRoutes} from "react-router-dom";
import {lazy} from "react";
import {LoadComponent} from "@loadComponent";

const List = lazy(() => import('./List'));

const ConferenceCalendar = () => {
    usePageTitle({title: 'Agendamentos', breadCrumbItems: []});

    return useRoutes([
        {
            path: '',
            element: <LoadComponent component={List}/>
        }
    ]);
};

export default ConferenceCalendar;
